<template>
  <div style="padding: 10px; font-size: 14px">
    <!-- {{ $t('questionnaire.index.9398859-0') }}/{{ $t('questionnaire.index.9398859-15') }}，传入当前语言代码 -->
    <Add
      :show="showAdd"
      @close="handlerCloseAdd"
      :editData="editData"
      :isEdit="isEdit"
      :languages="languages"
      :current-lang="currentLang"
    />

    <!-- 添加设备组件 -->
    <AddMachine
      :visible="showAddMachine"
      :surveyId="currentSurveyId"
      @close="handleCloseAddMachine"
      @success="getList"
    />

    <!-- 设备管理组件 -->
    <MachineConfig
      :visible="showMachineConfig"
      :surveyId="currentSurveyId"
      @close="handleCloseMachineConfig"
      @add-machine="handleAddMachine"
    />

    <!-- {{ $t('questionnaire.index.9398859-0') }} DataDisplay 组件 -->
    <DataDisplay :visible="showDataDisplay" :surveyId="currentSurveyId" @close="handleCloseDataDisplay" />

    <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
      <!-- 左 -->
      <div>
        <el-button @click="handlerAdd" size="small" type="primary" icon="el-icon-plus">{{
          $t("questionnaire.index.9398859-0")
        }}</el-button>
      </div>
      <!-- 右 -->
      <div style="display: flex">
        <el-input
          style="margin-right: 10px"
          size="small"
          v-model="search.title"
          :placeholder="$t('questionnaire.index.9398859-1')"
        ></el-input>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getList">{{
          $t("questionnaire.index.9398859-2")
        }}</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetSearch">{{
          $t("questionnaire.index.9398859-3")
        }}</el-button>
      </div>
    </div>
    <div>
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column prop="userName" :label="$t('questionnaire.index.9398859-4')" width="150"> </el-table-column>
        <el-table-column prop="nickName" :label="$t('questionnaire.index.9398859-5')" width="150"> </el-table-column>
        <el-table-column :label="$t('questionnaire.index.9398859-1')">
          <template slot-scope="scope">
            {{ getLocalizedTitle(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('questionnaire.index.9398859-6')" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.startTime) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('questionnaire.index.9398859-7')" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.endTime) }}
          </template>
        </el-table-column>
        <!-- 
        <el-table-column :label="$t('questionnaire.index.9398859-8')" width="100">
          <template slot-scope="scope">
            <el-tag :type="getSurveyStatus(scope.row).type">{{ getSurveyStatus(scope.row).text }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('questionnaire.index.9398859-9')" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.equipmentCount || 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('questionnaire.index.9398859-10')" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.responseCount || 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('questionnaire.index.9398859-11')" fixed="right" width="300">
          <template slot-scope="scope">
            <!-- <el-button style="margin-bottom: 4px" size="mini" @click="viewData(scope.row)">{{
              $t("questionnaire.index.9398859-12")
            }}</el-button> -->
            <el-button
              style="margin-bottom: 4px"
              type="warning"
              size="mini"
              icon="el-icon-folder-add"
              @click="handleAddMachine(scope.row)"
            >
              {{ $t("questionnaire.index.9398859-13") }}
            </el-button>
            <el-button
              style="margin-bottom: 4px"
              type="warning"
              size="mini"
              icon="el-icon-folder-opened"
              @click="handleMachineConfig(scope.row)"
            >
              {{ $t("questionnaire.index.9398859-14") }}
            </el-button>
            <!-- v-if="isShowEdit(scope.row)" -->
            <el-button style="margin-bottom: 4px" size="mini" icon="el-icon-edit" @click="editSurvey(scope.row)">{{
              $t("questionnaire.index.9398859-15")
            }}</el-button>
            <el-button
              style="margin-bottom: 4px"
              size="mini"
              icon="el-icon-delete"
              type="danger"
              @click="deleteSurvey(scope.row)"
              >{{ $t("questionnaire.index.9398859-16") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="tableData.length > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
        style="margin-top: 15px; text-align: right"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import Add from "./components/Add.vue";
  import AddMachine from "./components/AddMachine.vue";
  import MachineConfig from "./components/MachineConfig.vue";
  import DataDisplay from "./components/DataDisplay.vue"; // 导入数据显示组件

  export default {
    components: {
      Add,
      AddMachine,
      MachineConfig,
      DataDisplay // 注册组件
    },
    data() {
      return {
        search: {
          userName: "",
          nickName: "",
          title: ""
        },
        tableData: [],
        loading: false,
        showAdd: false,
        isEdit: false,
        editData: null,
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalSize: 0
        },
        languages: [],
        currentLang: "zh",
        showAddMachine: false,
        showMachineConfig: false,
        currentSurveyId: "", // 当前操作的问卷ID
        fromMachineConfig: false, // 添加这个标志变量
        showDataDisplay: false // 添加新数据
      };
    },
    created() {
      this.getList();
      this.getLanguages();
    },
    methods: {
      // 打开添加设备对话框
      handleAddMachine(row) {
        this.currentSurveyId = typeof row === "object" ? row.id : row;
        this.showAddMachine = true;

        // 记录是否从设备管理打开的
        this.fromMachineConfig = this.showMachineConfig;

        // 如果是从设备管理打开的，则关闭设备管理对话框
        if (this.showMachineConfig) {
          this.showMachineConfig = false;
        }
      },

      // 关闭添加设备对话框
      handleCloseAddMachine() {
        this.showAddMachine = false;

        // 如果是从设备管理打开的，则重新打开设备管理对话框
        if (this.fromMachineConfig) {
          this.showMachineConfig = true;
          this.fromMachineConfig = false; // 重置标志
        }
      },

      // 打开设备管理对话框
      handleMachineConfig(row) {
        this.currentSurveyId = row.id;
        this.showMachineConfig = true;
      },

      // 关闭设备管理对话框
      handleCloseMachineConfig() {
        this.showMachineConfig = false;
      },

      // 获取问卷列表
      async getList() {
        this.loading = true;
        const params = {
          ...this.search,
          pageIndex: this.page.pageIndex,
          pageSize: this.page.pageSize
        };

        const { data } = await this.$api.request(this.$url.Survey.page, this.$method.get, params);
        this.tableData = data.records || [];
        this.page.totalSize = parseInt(data.total) || 0;
        // 更新当前页码
        this.page.pageIndex = parseInt(data.current) || 1;
        this.loading = false;
      },

      // 重置搜索条件
      resetSearch() {
        this.search = {
          userName: "",
          nickName: "",
          title: ""
        };
        this.page.pageIndex = 1;
        this.getList();
      },

      // 添加问卷
      handlerAdd() {
        this.isEdit = false;
        this.editData = null;
        this.showAdd = true;
      },

      // 关闭添加/编辑弹窗
      handlerCloseAdd(hasChanged) {
        this.showAdd = false;
        if (hasChanged) {
          this.getList();
        }
      },

      // 编辑问卷
      editSurvey(row) {
        this.isEdit = true;
        this.editData = JSON.parse(JSON.stringify(row));
        this.currentLang = this.$cookies.get("lang") || "zh";
        this.showAdd = true;
      },

      // 删除问卷
      deleteSurvey(row) {
        this.$confirm(this.$t("questionnaire.index.9398859-17"), this.$t("questionnaire.index.9398859-18"), {
          confirmButtonText: this.$t("questionnaire.index.9398859-19"),
          cancelButtonText: this.$t("questionnaire.index.9398859-20"),
          type: "warning"
        })
          .then(async () => {
            try {
              const res = await this.$api.request(this.$url.Survey.delete, this.$method.delete, { id: row.id });
              if (res.code === 0) {
                this.$message.success(this.$t("questionnaire.index.9398859-21"));
                this.getList();
                return;
              }
              this.$message.error(res.msg);
            } catch (error) {
              console.error(this.$t("questionnaire.index.9398859-22"), error);
              this.$message.error(this.$t("questionnaire.index.9398859-22"));
            }
          })
          .catch(() => {});
      },

      // 查看数据
      viewData(row) {
        this.currentSurveyId = row.id;
        this.showDataDisplay = true;
      },

      // 关闭数据显示弹窗
      handleCloseDataDisplay() {
        this.showDataDisplay = false;
      },

      // 分页大小变化
      sizeChange(size) {
        this.page.pageSize = size;
        this.getList();
      },

      // 当前页变化
      currentChange(current) {
        this.page.pageIndex = current;
        this.getList();
      },

      // 获取本地化标题
      getLocalizedTitle(row) {
        if (!row.language || row.language.length === 0) return this.$t("questionnaire.index.9398859-23");

        // 获取当前设置的语言
        const currentLang = this.$cookies.get("lang");

        // 如果有当前语言的标题，优先显示
        if (currentLang) {
          const currLang = row.language.find(l => l.lang === currentLang);
          if (currLang) return currLang.title;
        }

        // 其次显示中文
        const zhLang = row.language.find(l => l.lang === "zh");
        if (zhLang) return zhLang.title;

        // 最后显示第一个语言
        return row.language[0].title;
      },

      // 格式化日期
      formatDate(date) {
        if (!date) return "";
        const d = new Date(date);
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const day = d.getDate().toString().padStart(2, "0");
        const hour = d.getHours().toString().padStart(2, "0");
        const minute = d.getMinutes().toString().padStart(2, "0");
        const second = d.getSeconds().toString().padStart(2, "0");
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      },
      isShowEdit(row) {
        const now = new Date();
        const startTime = new Date(row.startTime);
        if (now < startTime) return true;
        return false;
      },
      // 获取问卷状态
      getSurveyStatus(row) {
        const now = new Date();
        const startTime = new Date(row.startTime);
        const endTime = new Date(row.endTime);

        if (now < startTime) {
          return { type: "info", text: this.$t("questionnaire.index.9398859-24") };
        } else if (now > endTime) {
          return { type: "danger", text: this.$t("questionnaire.index.9398859-25") };
        } else {
          return { type: "success", text: this.$t("questionnaire.index.9398859-26") };
        }
      },

      // 获取语言列表
      async getLanguages() {
        try {
          const { data } = await this.$api.dict("sys_lang_list");
          this.languages = data.map(item => {
            return {
              code: item.value,
              name: item.label
            };
          });

          // 获取并设置当前语言代码
          this.currentLang = this.$cookies.get("lang") || "zh";
        } catch (error) {
          console.error(this.$t("questionnaire.index.9398859-27"), error);
          this.$message.error(this.$t("questionnaire.index.9398859-27"));
        }
      }
    }
  };
</script>

<style lang="scss" scoped></style>
